import axios from "@/plugins/axios";

let url = "/api/device-info";

export const deviceInfo = {
    get(data) {
        return axios.get(url, data).then((result) => result.data);
    },
};

export default deviceInfo;
